import img1 from "./WhatsApp Image 2025-11-27 at 7.04.08 AM.jpeg";
import img2 from "./WhatsApp Image 2025-11-27 at 7.04.11 AM (1).jpeg";
import img3 from "./WhatsApp Image 2025-11-27 at 7.04.11 AM (2).jpeg";
import img4 from "./WhatsApp Image 2025-11-27 at 7.04.11 AM.jpeg";
import img5 from "./WhatsApp Image 2025-11-27 at 7.04.12 AM (1).jpeg";
import img6 from "./WhatsApp Image 2025-11-27 at 7.04.12 AM (2).jpeg";
import img7 from "./WhatsApp Image 2025-11-27 at 7.04.12 AM.jpeg";
import img8 from "./WhatsApp Image 2025-11-27 at 7.04.13 AM (1).jpeg";
import img9 from "./WhatsApp Image 2025-11-27 at 7.04.13 AM (2).jpeg";
import img10 from "./WhatsApp Image 2025-11-27 at 7.04.13 AM.jpeg";
import img11 from "./WhatsApp Image 2025-11-27 at 7.04.14 AM (1).jpeg";
import img12 from "./WhatsApp Image 2025-11-27 at 7.04.14 AM (2).jpeg";
import img13 from "./WhatsApp Image 2025-11-27 at 7.04.14 AM.jpeg";
import img14 from "./WhatsApp Image 2025-11-27 at 7.04.15 AM (1).jpeg";
import img15 from "./WhatsApp Image 2025-11-27 at 7.04.15 AM.jpeg";
import img16 from "./WhatsApp Image 2025-11-27 at 7.04.16 AM (1).jpeg";
import img17 from "./WhatsApp Image 2025-11-27 at 7.04.16 AM (2).jpeg";
import img18 from "./WhatsApp Image 2025-11-27 at 7.04.16 AM.jpeg";
import img19 from "./WhatsApp Image 2025-11-27 at 7.04.17 AM (1).jpeg";
import img20 from "./WhatsApp Image 2025-11-27 at 7.04.17 AM.jpeg";
import img21 from "./WhatsApp Image 2025-11-27 at 7.04.19 AM (1).jpeg";
import img22 from "./WhatsApp Image 2025-11-27 at 7.04.19 AM (2).jpeg";
import img23 from "./WhatsApp Image 2025-11-27 at 7.04.19 AM.jpeg";
import img24 from "./WhatsApp Image 2025-11-27 at 7.04.21 AM (1).jpeg";
import img25 from "./WhatsApp Image 2025-11-27 at 7.04.21 AM.jpeg";
import img26 from "./WhatsApp Image 2025-11-27 at 7.04.22 AM (1).jpeg";
import img27 from "./WhatsApp Image 2025-11-27 at 7.04.22 AM (2).jpeg";
import img28 from "./WhatsApp Image 2025-11-27 at 7.04.22 AM.jpeg";
import img29 from "./WhatsApp Image 2025-11-27 at 7.04.23 AM.jpeg";
import img30 from "./WhatsApp Image 2025-11-27 at 7.04.24 AM.jpeg";
import img31 from "./WhatsApp Image 2025-11-27 at 7.04.25 AM (1).jpeg";
import img32 from "./WhatsApp Image 2025-11-27 at 7.04.25 AM (2).jpeg";
import img33 from "./WhatsApp Image 2025-11-27 at 7.04.25 AM.jpeg";
import img34 from "./WhatsApp Image 2025-11-27 at 7.04.26 AM.jpeg";
import img35 from "./WhatsApp Image 2025-11-27 at 7.04.27 AM (1).jpeg";
import img36 from "./WhatsApp Image 2025-11-27 at 7.04.27 AM (2).jpeg";
import img37 from "./WhatsApp Image 2025-11-27 at 7.04.27 AM.jpeg";
import img38 from "./WhatsApp Image 2025-11-27 at 7.04.28 AM (1).jpeg";
import img39 from "./WhatsApp Image 2025-11-27 at 7.04.28 AM (2).jpeg";
import img40 from "./WhatsApp Image 2025-11-27 at 7.04.28 AM (3).jpeg";
import img41 from "./WhatsApp Image 2025-11-27 at 7.04.28 AM.jpeg";
import img42 from "./WhatsApp Image 2025-11-27 at 7.04.29 AM (1).jpeg";
import img43 from "./WhatsApp Image 2025-11-27 at 7.04.29 AM (2).jpeg";
import img44 from "./WhatsApp Image 2025-11-27 at 7.04.29 AM.jpeg";
import img45 from "./WhatsApp Image 2025-11-27 at 7.04.30 AM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
];
